import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7d57be96&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d57be96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/lasur-lab/lasur-lab-admin-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d57be96')) {
      api.createRecord('7d57be96', component.options)
    } else {
      api.reload('7d57be96', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7d57be96&scoped=true", function () {
      api.rerender('7d57be96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/broadcastGoodList/broadcastGoodListFrom/index.vue"
export default component.exports